import { useMemo, useState } from "react";

import { TemplateRecommendationService } from "../../services/smart-ai/template-recommendation-service";

type UseTemplateRecommendationsOptions = {
  jobRole?: string;
  yearsOfExperience?: number;
  preferredStyle?: string;
  industry?: string;
};

const getTemplateProfile = (templateName: string) => {
  return TemplateRecommendationService.getTemplateProfile(templateName);
};

export const useTemplateRecommendations = (options: UseTemplateRecommendationsOptions = {}) => {
  const [showRecommendations, setShowRecommendations] = useState(false);

  const recommendations = useMemo(() => {
    if (!options.jobRole) return [];

    return TemplateRecommendationService.getRecommendations(
      options.jobRole,
      options.yearsOfExperience,
      options.preferredStyle,
      options.industry,
    );
  }, [options.jobRole, options.yearsOfExperience, options.preferredStyle, options.industry]);

  const topRecommendation = recommendations[0];

  const colorRecommendations = useMemo(() => {
    if (!options.jobRole) return [];

    const industry =
      options.industry ?? TemplateRecommendationService.detectIndustryFromJobRole(options.jobRole);
    return TemplateRecommendationService.getColorRecommendations(industry);
  }, [options.jobRole, options.industry]);

  const toggleRecommendations = () => {
    setShowRecommendations(!showRecommendations);
  };

  return {
    recommendations,
    topRecommendation,
    colorRecommendations,
    showRecommendations,
    toggleRecommendations,
    getTemplateProfile,
    hasRecommendations: recommendations.length > 0,
  };
};
